// Tek maskot: gülümseyen atom modeli; öğrenci rengini seçer.
export const MASCOTS = [
  ["orange", "Turuncu", "#FF7A1A"], ["yellow", "Sarı", "#FACC15"], ["lime", "Fıstık", "#A3E635"], ["green", "Yeşil", "#22C55E"],
  ["teal", "Turkuaz", "#14B8A6"], ["sky", "Gök", "#38BDF8"], ["blue", "Mavi", "#3B82F6"], ["indigo", "Lacivert", "#6366F1"],
  ["purple", "Mor", "#A855F7"], ["pink", "Pembe", "#EC4899"], ["red", "Kırmızı", "#EF4444"], ["white", "Beyaz", "#E5E7EB"],
];

const ORBITS = [0, 60, -60];

export const Mascot = ({ id, size = 48, className = "" }) => {
  const m = MASCOTS.find((x) => x[0] === id) || MASCOTS[0];
  const c = m[2];
  return (
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" width={typeof size === "number" ? size : undefined} height={typeof size === "number" ? size : undefined} style={{ width: size, height: size }} className={className} aria-label={`${m[1]} atom`} role="img" data-testid={`mascot-${m[0]}`}>
      {ORBITS.map((r) => <ellipse key={r} cx="32" cy="32" rx="29" ry="10.5" fill="none" stroke={c} strokeOpacity="0.75" strokeWidth="2.6" transform={`rotate(${r} 32 32)`} />)}
      <circle cx="61" cy="32" r="3.2" fill={c} />
      <circle cx="17.5" cy="7" r="3.2" fill={c} />
      <circle cx="17.5" cy="57" r="3.2" fill={c} />
      <circle cx="32" cy="32" r="15" fill={c} />
      <circle cx="26" cy="25" r="4.5" fill="#fff" fillOpacity="0.35" />
      <circle cx="27" cy="31" r="2.6" fill="#0B0F16" /><circle cx="37" cy="31" r="2.6" fill="#0B0F16" />
      <circle cx="27.8" cy="30.2" r="0.9" fill="#fff" /><circle cx="37.8" cy="30.2" r="0.9" fill="#fff" />
      <circle cx="23.5" cy="36" r="2" fill="#F43F5E" fillOpacity="0.45" /><circle cx="40.5" cy="36" r="2" fill="#F43F5E" fillOpacity="0.45" />
      <path d="M27.5 37 q4.5 4.2 9 0" stroke="#0B0F16" strokeWidth="2.2" fill="none" strokeLinecap="round" />
    </svg>
  );
};

export const MascotPicker = ({ value, onPick }) => (
  <div className="panel p-5 space-y-4" data-testid="mascot-picker">
    <div className="flex items-center gap-4">
      <Mascot id={value || "orange"} size={64} className="anim-bob shrink-0" />
      <div>
        <p className="font-display text-xl font-bold">Atomunun rengini seç</p>
        <p className="text-sm text-slate-400">Tahtada masanda bu renkle görüneceksin.</p>
      </div>
    </div>
    <div className="grid grid-cols-6 gap-2">
      {MASCOTS.map(([id, label, color]) => (
        <button key={id} type="button" onClick={() => onPick(value === id ? null : id)} title={label} aria-label={label} data-testid={`pick-mascot-${id}`}
          className={`aspect-square rounded-2xl border-2 grid place-items-center bg-white/5 transition-transform duration-150 hover:scale-110 ${value === id ? "scale-110" : "border-transparent"}`}
          style={value === id ? { borderColor: color, boxShadow: `0 0 16px ${color}88` } : undefined}>
          <span className="h-7 w-7 rounded-full" style={{ backgroundColor: color }} />
        </button>
      ))}
    </div>
  </div>
);
